import { apiFetch } from './client';
import type { BeAuction } from './auctions';

export interface BeFavorite {
  id: string;
  userId: string;
  auctionId: string;
  notes?: string;
  createdAt: string;
  auction: BeAuction;
}

export const favoritesApi = {
  list: () => apiFetch<BeFavorite[]>('/favorites'),

  add: (opportunityId: string, notes?: string) =>
    apiFetch<BeFavorite>('/favorites', {
      method: 'POST',
      body: { opportunityId, notes },
    }),

  remove: (opportunityId: string) =>
    apiFetch<void>(`/favorites/${opportunityId}`, { method: 'DELETE' }),

  updateNotes: (opportunityId: string, notes: string) =>
    apiFetch<BeFavorite>(`/favorites/${opportunityId}/notes`, {
      method: 'PATCH',
      body: { notes },
    }),
};
